import React, { useEffect, useState } from 'react';

/**
 * @param {object} props
 * @param {string} props.name name used for class & id of elements
 * @param {string} props.title Visible title to identify accordian
 * @param {any} props.collapsed If present or "truthy", starts collapsed
 * @param {any} props.refreshable If present, send "refreshSignal" prop on Children and show refresh button
 */
export default function AccordianItem(props) {
	const { name, title, collapsed, refreshable, className } = props;
	const [refreshSignal, setRefreshSignal] = useState(false);

	let isCollapsed = localStorage.getItem(`ecom_Accordian_collapsed_${name}`);
	if (isCollapsed === null) {
		isCollapsed = collapsed
	} else {
		// string to boolean
		isCollapsed = (isCollapsed === "true");
	}
	useEffect(() => {
		document.querySelector(`#${name}_collapse`)?.addEventListener("show.bs.collapse", () => {
			localStorage.setItem(`ecom_Accordian_collapsed_${name}`, "false");
		});
		document.querySelector(`#${name}_collapse`)?.addEventListener("hide.bs.collapse", () => {
			localStorage.setItem(`ecom_Accordian_collapsed_${name}`, "true");
		});
	}, []);

	/**
	 * Event handlers
	 * @param {Event} event
	 */
	const refreshHandler = (event) => {
		setRefreshSignal(refreshSignal+1)
	}

	/**
	 * render
	 */
	const refreshButton = () => {
		if (refreshable) {
			return (<button type="button" className="refresh-button-icon" onClick={refreshHandler}><i className="bi bi-arrow-clockwise"></i></button>);
		} else {
			return null;
		}
	}
	return (
		<div className={`accordion-item ${name} ${className}`}>
			<h2 className="accordion-header" id={`${name}_heading`}>
				<button
					type="button"
					className={`accordion-button ${isCollapsed ? 'collapsed' : ''}`}
					data-bs-toggle="collapse"
					data-bs-target={`#${name}_collapse`}
					aria-expanded={isCollapsed ? 'false' : 'true'}
					aria-controls={`${name}_collapse`}
				>{title}<span className="accordion-button-icon"></span></button>
				{refreshButton()}
			</h2>
			<div
				id={`${name}_collapse`}
				className={`accordion-collapse collapse ${isCollapsed ? '' : 'show'}`}
				aria-labelledby={`${name}_heading`}
			>
				<div className="accordion-body">
					{refreshable ?
						React.Children.map(props.children, child => {
							// https://stackoverflow.com/a/68080735/
							if (typeof child.type === 'function') {
								return React.cloneElement(child, {'refreshSignal': refreshSignal});
							} else {
								return child;
							}
						}) :
						props.children
					}
				</div>
			</div>
		</div>
	);
}